export default __webpack_public_path__ + "static/media/(29).83319456.jpg";